(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rebuy-collection-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rebuy-collection-filters')) {
    class RebuyFilters extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.container = this.querySelectorAll('.accordion-list');
        this.activeFiltersContainer = this.querySelector('#rebuy-active-facets');
        this.openFilters = [];

        if(this.container.length) {
          document.addEventListener('rebuy:renderFilters', this.renderFilters.bind(this), {
            signal: this.abortController.signal,
          });

          this.container.forEach(container => {
            container.addEventListener('filter-container:toggle', this.filterDrawerToggle.bind(this), {
              signal: this.abortController.signal
            })
            container.addEventListener('change', this.toggleFilter.bind(this), {
              signal: this.abortController.signal
            })
          })
        }

        if (this.activeFiltersContainer) {
          document.addEventListener('rebuy:renderActiveFacets', this.renderActiveFacets.bind(this), {
            signal: this.abortController.signal,
          });
          this.activeFiltersContainer.addEventListener('click', this.removeFilterHandler.bind(this), {
            signal: this.abortController.signal,
          });
        }
      }

      _handleize(string) {
        return string.replaceAll(/\W/gm, '-').replaceAll(/\W(-*)\W/gm, "-")
      }

      filterDrawerToggle(evt) {
        const detail = evt.srcElement;
        const label = detail.dataset.rebuyFilter;

        this.openFilters[label] = detail.open;

        this.container.forEach(container => {
          const drawer = container.querySelector(`[data-rebuy-filter="${label}"]`)
          if(detail.open) {
            drawer.setAttribute('open', true);
            drawer.setAttribute('aria-expanded', 'true');
          } else {
            drawer.removeAttribute('open', true);
            drawer.removeAttribute('aria-expanded');
          }
        })
      }

      toggleFilter(evt) {
        const filter = evt.target;
        const type = filter.name;
        const value = filter.value;

        this.container.forEach(container => {
          const cloneFilter = container.querySelector(`[id="${filter.id}"]`);

          if(cloneFilter.type == 'checkbox') {
            cloneFilter.toggleAttribute('checked', filter.checked);
          } else {
            cloneFilter.value = value;
          }
        })

        document.dispatchEvent(new CustomEvent('rebuy:filter:toggle', {
          detail: {
            key: type.replace('filter.',''),
            value: value
          }
        }))
      }

      renderFilters(evt) {
        const { aggregates, filterSettings, config } = evt.detail;
        const filterBlocks = [];

        if(typeof this.openFilters == 'undefined') {
          this.openFilters = {};

          aggregates.forEach(aggregate => {
            this.openFilters[aggregate.label] = config.openFiltersByDefault;
          })
        }

        aggregates.forEach((aggregate) => {
          switch (aggregate.type) {
            case 'available':
              filterBlocks.push(`
                <details class="accordion  group" data-rebuy-filter="${aggregate.label}" is="accordion-disclosure" ${this.openFilters[aggregate.label] ? 'open aria-expanded="true"' : 'aria-expanded="false"'}
                  ontoggle="this.dispatchEvent(new CustomEvent('filter-container:toggle', {bubbles: true}))">
                  <summary>
                    <span class="accordion__toggle h6">
                      <span class="text-with-icon gap-4">${aggregate.label}</span>
                      <svg aria-hidden="true" focusable="false" fill="none" width="10" class="group-expanded:rotate icon icon-chevron-down" viewBox="0 0 10 10">
                        <path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"></path>
                      </svg>
                    </span>
                  </summary>

                  <div class="accordion__content " style="opacity: 1; transform: translateY(0px);">
                    <div class="checkbox-control">
                      <input id="facets-sidebar-filter.available" type="checkbox" class="switch" name="${aggregate.type}" value="true" ${evt.detail.filters.available == true ? 'checked' : ''}>
                      <label for="facets-sidebar-filter.available" class="text-subdued">In stock only</label>
                    </div>
                  </div>
                </details>
              `);
            break;
            case 'price':
              filterBlocks.push(`
              <details class="accordion  group " data-rebuy-filter="${aggregate.label}" is="accordion-disclosure" ${this.openFilters[aggregate.label] ? 'open aria-expanded="true"' : 'aria-expanded="false"'}
                ontoggle="this.dispatchEvent(new CustomEvent('filter-container:toggle', {bubbles: true}))">
                <summary>
                  <span class="accordion__toggle h6"><span class="text-with-icon gap-4">${aggregate.label}</span>
                  <svg aria-hidden="true" focusable="false" fill="none" width="10" class="group-expanded:rotate icon icon-chevron-down" viewBox="0 0 10 10">
                    <path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"></path>
                  </svg>
                  </span>
                </summary>

                <div class="accordion__content " style="opacity: 1; transform: translateY(0px);">
                  <price-range class="price-range">
                    <div class="range-group no-js:hidden" style="--range-min: 0.0%; --range-max: ${(evt.detail.filters.price.max||200000 / 100)/2000 * 100 }%">
                      <input type="range" aria-label="From price" class="range" min="0" max="2000" step="20" value="${evt.detail.filters.price.min / 100 || 0}">
                      <input type="range" aria-label="To price" class="range" min="0" max="2000" step="20" value="${evt.detail.filters.price.max / 100 || 2000}">
                    </div>

                    <div class="input-group">
                      <label class="input-prefix text-sm">
                        <span class="prefix text-subdued">${config.priceSymbol}</span>
                        <input aria-label="From price" class="field" type="number" inputmode="numeric" name="filter.v.price.gte" id="filter.v.price.gte" min="0" max="2000" step="20" placeholder="0" value="${evt.detail.filters.price.min / 100}" autocomplete="off">
                      </label>

                      <span class="text-subdued text-sm">to</span>

                      <label class="input-prefix text-sm">
                        <span class="prefix text-subdued">${config.priceSymbol}</span>
                        <input aria-label="To price" class="field" type="number" inputmode="numeric" name="filter.v.price.lte" id="filter.v.price.lte" min="0" max="2000" step="20" placeholder="2000" value="${evt.detail.filters.price.max / 100}" autocomplete="off">
                      </label>
                    </div>
                  </price-range>
                </div>
              </details>`)
            break;
            default:
              let dropdownContent = `
                  <div class="v-stack gap-2.5">
                    ${aggregate.values.map(value => {
                      let checked = false;
                      if(evt.detail.filters[aggregate.type].findIndex((loopValue) => loopValue == value.value) > -1){
                        checked = true;
                      }
                      return `<div class="checkbox-control">
                        <input id="checkbox-facets-sidebar-1-template--26280586215740__main--filter.${aggregate.type}-${aggregate.name}-${this._handleize(value.value)}" class="checkbox" type="checkbox" name="${aggregate.type}" value="${value.value}" ${checked ? 'checked' : ""}>
                        <label for="checkbox-facets-sidebar-1-template--26280586215740__main--filter.${aggregate.type}-${aggregate.name}-${this._handleize(value.value)}">${value.label}
                          ${event.detail.config.showFilterValuesCount ? `(${value.numProducts})`:''}
                        </label>
                      </div>`
                    }).join('')}
                  </div>
              `

              if(aggregate.name == 'color') {
                dropdownContent = `
                  <div class="h-stack gap-2 wrap">
                    ${aggregate.values.map(value => {
                      let checked = false;

                      if(evt.detail.filters[aggregate.type].findIndex((loopValue) => loopValue == value.value) > -1){
                        checked = true;
                      }
                      return `<input class="sr-only" type="checkbox" name="${aggregate.type}" id="swatch-facets-sidebar-1-template--26280586215740__main--${aggregate.type}-${aggregate.name}-${this._handleize(value.value)}" value="${value.value}" ${checked ? 'checked' : ""}>
                      <label class="color-swatch ${config.roundColorSwatches ? 'rounded-full' : ''}" for="swatch-facets-sidebar-1-template--26280586215740__main--${aggregate.type}-${aggregate.name}-${this._handleize(value.value)}" data-tooltip="${value.label}" data-option-value="" style="--swatch-background: ${evt.detail.config.colorSwatchMap[value.label.toLowerCase()]}">
                        <span class="sr-only">${value.label}</span>
                      </label>`
                    }).join('')}
                  </div>
                `
              }
              filterBlocks.push(`
                <details class="accordion  group" data-rebuy-filter="${aggregate.label}" is="accordion-disclosure" ${this.openFilters[aggregate.label] ? 'open aria-expanded="true"' : 'aria-expanded="false"'}
                  ontoggle="this.dispatchEvent(new CustomEvent('filter-container:toggle', {bubbles: true}))">
                  <summary>
                    <span class="accordion__toggle h6">
                      <span class="text-with-icon gap-4">${aggregate.label}</span>
                      <svg aria-hidden="true" focusable="false" fill="none" width="10" class="group-expanded:rotate icon icon-chevron-down" viewBox="0 0 10 10">
                        <path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"></path>
                      </svg>
                    </span>
                  </summary>
                  <div class="accordion__content " style="opacity: 1; transform: translateY(0px);">
                   ${dropdownContent}
                  </div>
                </details>
              `)
            break;
          }
        });

        this.container.forEach(container => container.querySelectorAll('[data-rebuy-filter]').forEach(item => item.remove()))

        this.container.forEach(container => {
          container.innerHTML += filterBlocks.join('');
        })
      }

      renderActiveFacets(evt) {
        const {filters, config} = evt.detail;
        const activeFilters = [];
        for (const [key, values] of Object.entries(filters)) {
          switch (key) {
          case "available":
            if(values) {
              activeFilters.push(`
                <button class="removable-facet" data-filter-key="${key}" data-filter-value="">
                  <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
                    <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.2"></path>
                  </svg>
                  In Stock
                </button>
              `);
            }
          break;
          case "price":
            if(values.min || values.max) {
              activeFilters.push(`
                <button class="removable-facet" data-filter-key="${key}" data-filter-value="">
                  <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
                    <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.2"></path>
                  </svg>
                  ${config.currencySymbol}${(values.min / 100) || 0} - ${config.currencySymbol}${(values.max / 100) || 2000}
                </button>
              `);
            }
          break;
          default:
            values.forEach((value) => {
              let filterLabel = value;

              if(value.indexOf("#") > -1) {
                filterLabel = value.split('#')[1].trim();
              }
              activeFilters.push(`
                <button class="removable-facet" data-filter-key="${key}" data-filter-value="${value}">
                  <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
                    <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.2"></path>
                  </svg>
                  ${filterLabel.replace(/^(variant|product)\.custom\.([\w-]+)\./gm, '')}
                </button>
              `);
            });
          break;
          }
        }

        if (activeFilters.length > 1) {
          activeFilters.push(`
            <button type="button" class="facets-clear-all text-subdued" data-clear-filters>
              <span class="link">Clear All</span>
            </button>
          `);
        }

        if (activeFilters.length) {
          this.activeFiltersContainer.style.removeProperty('display');
          this.activeFiltersContainer.innerHTML = activeFilters.join('');
        } else {
          this.activeFiltersContainer.style.setProperty('display', 'none');
        }
      }

      removeFilterHandler(evt) {
        if (evt.target.dataset?.filterKey) {
          document.dispatchEvent(
            new CustomEvent('rebuy:filter:toggle', {
              detail: { key: evt.target.dataset.filterKey, value: evt.target.dataset.filterValue },
            })
          );
        }

        if (evt.target.closest('[data-clear-filters]')) {
          document.dispatchEvent(new CustomEvent('rebuy:filter:reset'));
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('rebuy-collection-filters', RebuyFilters);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rebuy-product-card"] && !Shopify.designMode) return;
  try {
    class RebuyProductCard extends HTMLElement {
  constructor() {
    super();
  }

  static get observedAttributes() { return ['data-product']; }

  // ─── UTILITIES ─────────────────────────────────────────────────────────

  _escHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  _formatMoney(cents) {
    if (cents == null) return '';
    return `$${(cents / 100).toFixed(2)}`;
  }

  _resizeImage(url, width) {
    if (!url) return '';
    if (url.indexOf('cdn.shopify.com') !== -1) {
      return url.replace(/(\.[a-z]+)(\?|$)/, `_${width}x$1$2`);
    }
    return url;
  }

  _buildSrcset(url) {
    return [100, 150, 200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600]
      .map((w) => `${this._resizeImage(url, w)} ${w}w`)
      .join(', ');
  }

  // ─── SWATCH HELPERS ────────────────────────────────────────────────────

  _isColorOptionGroup(optionName) {
    var n = (optionName || '').toLowerCase().trim();
    return n === 'color' || n === 'colour';
  }

  _getColorSwatchStyle(label, config) {
    var map   = config && config.colorSwatchMap;
    var key   = String(label).toLowerCase().trim();
    var style = map && typeof map === 'object' ? map[key] : null;
    if (style) return `--swatch-background: ${style}`;
    return `--swatch-background: linear-gradient(to right, ${key}, ${key})`;
  }

  _getProductColorValues(product) {
    if (!product.options || !Array.isArray(product.options)) return null;
    for (var i = 0; i < product.options.length; i++) {
      var opt = product.options[i];
      if (opt && typeof opt === 'object' && this._isColorOptionGroup(opt.option)) {
        return { position: opt.position || (i + 1), values: opt.values || [] };
      }
    }
    return null;
  }

  _buildSwatchHtml(product, config) {
    var colorOption = this._getProductColorValues(product);
    if (!colorOption || colorOption.values.length === 0) return '';

    var roundSwatches = !!config.roundColorSwatches;
    var whiteLabel    = (typeof config.whiteLabel === 'string' ? config.whiteLabel : 'white').toLowerCase();
    var name          = `swatch-rebuy-${product.id}`;

    var items = colorOption.values.map((value, i) => {
      var valueDown   = String(value).toLowerCase().trim();
      var id          = `rebuy-swatch-${product.id}-${i}`;
      var swatchClass = `color-swatch${roundSwatches ? ' rounded-full' : ''}${valueDown === whiteLabel ? ' border' : ''}`;
      var swatchStyle = this._getColorSwatchStyle(value, config);
      return `
        <input
          class="sr-only"
          type="radio"
          name="${this._escHtml(name)}"
          id="${id}"
          value="${this._escHtml(value)}"
          ${i === 0 ? 'checked' : ''}
        />
        <label
          class="${swatchClass}"
          for="${id}"
          data-tooltip="${this._escHtml(value)}"
          data-option-value
          style="${this._escHtml(swatchStyle)}"
        >
          <span class="sr-only">${this._escHtml(value)}</span>
        </label>
      `;
    }).join('');

    return `
      <fieldset class="h-stack wrap justify-center gap-1" data-option-position="${colorOption.position}">
        ${items}
      </fieldset>
    `;
  }

  // ─── CARD HTML BUILDER ─────────────────────────────────────────────────
  // Pure function: receives product data + config and returns an HTML string.
  // isEager: true for the first cards (above the fold) -> loading=eager.

  _buildProductCardInnerHtml(product, config, isEager) {
    var isAvailable  = product.canPurchase !== false;
    var imageUrl     = product.images && product.images.length > 0 ? (product.images[0].url || product.images[0]) : '';
    var secondaryUrl = product.images && product.images.length > 1 ? (product.images[1].url || product.images[1]) : '';
    var productUrl   = `/products/${product.handle}`;
    var variant      = product.variants && product.variants.length > 0 ? product.variants[0] : {};
    var isOnSale     = variant.compareAtPrice && variant.compareAtPrice > variant.price;

    var aspectClass     = 'aspect-natural';
    if (config.productImageAspectRatio) aspectClass = `aspect-${config.productImageAspectRatio.split('_')[0]}`;
    var cropClass       = config.productImageAspectRatio && config.productImageAspectRatio.indexOf('crop') !== -1 ? ' object-cover' : '';
    var textClass       = config.productCardTextFont === 'heading' ? 'h6' : '';
    var titleClampClass = config.productTitleMaxLines > 0 ? ' line-clamp' : '';
    var titleClampStyle = config.productTitleMaxLines > 0 ? ` style="--line-clamp-count: ${config.productTitleMaxLines}"` : '';
    var loadingAttr     = isEager ? 'eager' : 'lazy';
    var priorityAttr    = isEager ? ' fetchpriority="high"' : '';
    var priceClass      = textClass ? `${textClass} ` : '';
    var salePriceClass  = isOnSale ? `${priceClass}text-on-sale` : `${priceClass}text-subdued`;
    var compareClass    = `${priceClass}text-subdued line-through`;

    var vendorHtml = '';
    if (config.showVendor && product.vendor) {
      var vendorName = String(product.vendor).trim();
      if (vendorName) {
        vendorHtml = `<a href="/collections/vendors?q=${encodeURIComponent(vendorName)}" class="vendor smallcaps heading" data-instant>${this._escHtml(vendorName)}</a>`;
      }
    }

    return `
      ${imageUrl ? `
        <div class="product-card__figure">
          ${!isAvailable && config.showSoldOutBadge
            ? `<badge-list class="badge-list badge-list--vertical">
                 <span class="badge badge--sold-out">${config.soldOutText}</span>
               </badge-list>`
            : isOnSale && config.showDiscount
              ? `<badge-list class="badge-list badge-list--vertical">
                   <span class="badge badge--on-sale">Sale</span>
                 </badge-list>`
              : ''
          }
          <a href="${productUrl}" class="product-card__media" data-instant>
            <img
              class="product-card__image product-card__image--primary ${cropClass} ${aspectClass}"
              src="${this._resizeImage(imageUrl, 800)}"
              srcset="${this._buildSrcset(imageUrl)}"
              sizes="(min-width: 999px) 30vw, (min-width: 699px) 40vw, 50vw"
              loading="${loadingAttr}"${priorityAttr}
              alt="${this._escHtml(product.name)}"
            />
            ${secondaryUrl ? `
              <img
                class="product-card__image product-card__image--secondary"
                src="${this._resizeImage(secondaryUrl, 800)}"
                srcset="${this._buildSrcset(secondaryUrl)}"
                loading="lazy"
                fetchpriority="low"
                sizes="(min-width: 999px) 30vw, (min-width: 699px) 40vw, 50vw"
              />
            ` : ''}
          </a>
        </div>
      ` : ''}
      ${!config.hideProductInformation ? `
        <div class="product-card__info empty:hidden">
          <div class="v-stack justify-items-center gap-2">
            ${vendorHtml}
            <div class="v-stack justify-items-center gap-1">
              <a href="${productUrl}" class="product-title ${textClass}${titleClampClass}"${titleClampStyle} data-instant>
                ${this._escHtml(product.name)}
              </a>
              <price-list class="price-list">
                <sale-price class="${salePriceClass}">
                  <span class="sr-only">${config.salePriceText}</span>
                  ${this._formatMoney(product.price)}
                </sale-price>
                ${isOnSale ? `
                  <compare-at-price class="${compareClass}">
                    <span class="sr-only">Original price</span>
                    ${this._formatMoney(variant.compareAtPrice)}
                  </compare-at-price>
                ` : ''}
              </price-list>
            </div>
          </div>
          ${this._buildSwatchHtml(product, config)}
          ${config.showProductRating ? `
          <div
            class="yotpo-widget-instance"
            data-yotpo-instance-id="1229783"
            data-yotpo-product-id="${product.id}"
            data-yotpo-cart-product-id=""
            data-yotpo-section-id="product"
          ></div>
          ` : ''}
        </div>
      ` : ''}
    `;
  }

  // ─── WEB COMPONENT ─────────────────────────────────────────────────────

  connectedCallback() {
    this.abortController = new AbortController();
    this.addEventListener('change', this._onSwatchChanged.bind(this), {
      signal: this.abortController.signal
    });
    if (this.childElementCount > 0) return;
    this._render();
  }

  // Re-renders when `data-product` changes after the element is already in the DOM.
  // Skips the initial call (oldValue === null) because connectedCallback handles that.
  attributeChangedCallback(name, oldValue, newValue) {
    if (!this.isConnected || oldValue === null || newValue === null || oldValue === newValue) return;
    this.innerHTML = '';
    this._render();
  }

  _onSwatchChanged(e) {
    const radio = e.target;
    if (!radio || radio.type !== 'radio' || !radio.name.startsWith('swatch-rebuy-')) return;

    const product = this._productData;
    if (!product) return;



    const fieldset = radio.closest('[data-option-position]');
    if (!fieldset) return;

    const optionPosition = fieldset.getAttribute('data-option-position');
    const variant = product.variants.find(function (v) {
      const optionAttribute = v.customAttributes.find((loopAttr) => {
        return loopAttr.name == 'option' + optionPosition;
      })

      return optionAttribute.value === radio.value;
    });
    if (!variant) return;

    const handle = product.handle;
    this.querySelectorAll('a[href*="/products/' + handle + '"]').forEach(function (link) {
      link.href = variant.url;
    });

    const imgUrl = variant.images[0].url;
    if (!imgUrl) return;

    const primaryImg   = this.querySelector('.product-card__image--primary');
    const secondaryImg = this.querySelector('.product-card__image--secondary');

    if (primaryImg) {
      primaryImg.src    = this._resizeImage(imgUrl, 800);
      primaryImg.srcset = this._buildSrcset(imgUrl);
    }
    if (secondaryImg) {
      const secondaryUrl = product.images && product.images[1]
        ? (product.images[1].url || product.images[1])
        : imgUrl;
      secondaryImg.src    = this._resizeImage(secondaryUrl, 800);
      secondaryImg.srcset = this._buildSrcset(secondaryUrl);
    }
  }

  _render() {
    var raw = this.dataset.product;
    if (!raw) return;
    try {
      var product = JSON.parse(raw);
      var isEager = this.dataset.eager === 'true';
      this._productData = product;
      delete this.dataset.product;
      delete this.dataset.eager;
      this.innerHTML = this._buildProductCardInnerHtml(
        product,
        window.__productCardConfig || {},
        isEager
      );
    } catch (e) {}
  }

  disconnectedCallback() {
    this.abortController.abort();
  }
}

if (!customElements.get('rebuy-product-card')) {
  customElements.define('rebuy-product-card', RebuyProductCard);
}
  } catch(e) { console.error(e); }
})();

})();
